export const countries = [
  {
    label: "Argentina",
    value: "ARGENTINA",
  },
  {
    label: "Bolivia",
    value: "BOLIVIA",
  },
  {
    label: "Chile",
    value: "CHILE",
  },
  {
    label: "Colombia",
    value: "COLOMBIA",
  },
  {
    label: "Costa Rica",
    value: "COSTA RICA",
  },
  {
    label: "Cuba",
    value: "CUBA",
  },
  {
    label: "Ecuador",
    value: "ECUADOR",
  },
  {
    label: "El Salvador",
    value: "EL SALVADOR",
  },
  {
    label: "Honduras",
    value: "HONDURAS",
  },
  {
    label: "México",
    value: "MEXICO",
  },
  {
    label: "Panamá",
    value: "PANAMA",
  },
  {
    label: "Perú",
    value: "PERU",
  },
  {
    label: "United States",
    value: "UNITED STATES",
  },
  {
    label: "Uruguay",
    value: "URUGUAY",
  },
  {
    label: "Venezuela",
    value: "VENEZUELA",
  },
];

export enum Country {
  ARGENTINA = "Argentina",
  COLOMBIA = "Colombia",
  CHILE = "Chile",
  COSTA_RICA = "Costa Rica",
  CUBA = "Cuba",
  ECUADOR = "Ecuador",
  EL_SALVADOR = "El Salvador",
  PERU = "Perú",
  MEXICO = "México",
  VENEZUELA = "Venezuela",
  URUGUAY = "Uruguay",
  UNITED_STATES = "United States",
  HONDURAS = "Honduras",
  BOLIVIA = "Bolivia",
  PANAMA = "Panamá",
}
